import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Week } from 'src/app/classes/week';
import { CodaltComponent } from 'src/app/codalt.component';

/** Keuzes voor de herverloning. */
@Component({
    selector: 'app-resettle-options-dialog',
    templateUrl: './resettle-options-dialog.component.html',
    styleUrls: ['./resettle-options-dialog.component.scss'],
    standalone: false,
})
export class ResettleOptionsDialogComponent extends CodaltComponent {
    recalculateTravel: boolean;

    constructor(
        public dialogRef: MatDialogRef<ResettleOptionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            recalculateTravel: boolean;
            week?: Week;
        }
    ) {
        super();

        this.recalculateTravel = data.recalculateTravel ?? true;
    }

    /** Waar de herverloning over gaat: één week of de hele periode. */
    get scopeLabel() {
        return this.data.week ? `Week ${this.data.week.weeknumber}` : 'De periode';
    }

    confirm() {
        this.dialogRef.close({ recalculateTravel: this.recalculateTravel });
    }
}
